import { Component } from '@angular/core';
import { ApiEnterpriseBackgroundPosition } from './api-enterprise-section/api-enterprise-section.component';

@Component({
  selector: 'app-home-page-api-enterprise-v4',
  template: `
    <fl-bit class="ApiEnterprise">
      <fl-bit class="ApiEnterprise-section">
        <app-home-page-api-enterprise-section
          class="ApiEnterprise-section-content"
          cta="View Documentation"
          i18n-cta="
            Label of View Documentation button for the Freelancer API blade
          "
          description="Why hire people when you can simply integrate our talented cloud
      workforce instead?"
          i18n-description="Freelancer API Blade description"
          header="Freelancer API."
          i18n-header="Freelancer API Blade Header"
          subheader="50 million professionals on demand"
          i18n-subheader="Freelancer API Blade Subheader"
          [apiEnterpriseBackgroundPosition]="
            ApiEnterpriseBackgroundPosition.LEFT
          "
          [backgroundSrc]="'home/api-enterprise/api-upsell-v3.jpg'"
          [link]="'https://developers.freelancer.com/'"
          [trackingLabel]="'ApiUpsell-ApiButton'"
        ></app-home-page-api-enterprise-section>
      </fl-bit>

      <fl-bit class="ApiEnterprise-section">
        <app-home-page-api-enterprise-section
          i18n-link]
          class="ApiEnterprise-section-content ApiEnterprise-section-content--enterprise"
          cta="Contact Us"
          i18n-cta="Label of contact button for the Freelancer Enterprise blade"
          description="Use our workforce of 50 million to help your business achieve more."
          i18n-description="Freelancer Enterprise Blade description"
          header="Freelancer Enterprise."
          i18n-header="Freelancer Enterprise Blade Header"
          subheader=" Company budget? Get more done for less"
          i18n-subheader="Freelancer Enterprise Blade Subheader"
          [apiEnterpriseBackgroundPosition]="
            ApiEnterpriseBackgroundPosition.RIGHT
          "
          [backgroundSrc]="'home/api-enterprise/enterprise-upsell-v3.jpg'"
          [link]="'/enterprise'"
          [trackingLabel]="'ApiUpsell-EnterpriseButton'"
        ></app-home-page-api-enterprise-section>
      </fl-bit>
    </fl-bit>
  `,
  styleUrls: ['./api-enterprise-v4.component.scss'],
})
export class HomePageApiEnterpriseV4Component {
  ApiEnterpriseBackgroundPosition = ApiEnterpriseBackgroundPosition;
}
